import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Seckbd from './seckbd.vue'

export const seckbdProps = buildProps({
  options: {
    type: Object,
    default: () => ({}),
  },
})

export const seckbdEmits = {
  click: (e: string, item: any, ot: any) => e,
  'handle-click': (item: any, ot: any) => item,
  error: (error: any) => error,
}

export type SeckbdProps = ExtractPropTypes<typeof seckbdProps>
export type SeckbdEmits = typeof seckbdEmits
export type SeckbdInstance = InstanceType<typeof Seckbd>
